import { CheckCircle2, AlertCircle } from "lucide-react";
import type { SetupField } from "@shared/buy-box-setup";

export function SetupCompletenessBanner({
  missing,
  total,
  readyLabel,
  testIdPrefix,
}: {
  missing: SetupField[];
  total: number;
  readyLabel: string;
  testIdPrefix: string;
}) {
  const filled = total - missing.length;

  if (missing.length === 0) {
    return (
      <div
        className="flex items-center gap-2 rounded-lg border border-green-200 bg-green-50 px-4 py-3 mb-6"
        data-testid={`banner-${testIdPrefix}-ready`}
      >
        <CheckCircle2 className="h-5 w-5 text-green-600 shrink-0" />
        <p className="text-sm font-medium text-green-800">{readyLabel}</p>
      </div>
    );
  }

  return (
    <div
      className="rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 mb-6"
      data-testid={`banner-${testIdPrefix}-incomplete`}
    >
      <div className="flex items-center gap-2 mb-2">
        <AlertCircle className="h-5 w-5 text-amber-600 shrink-0" />
        <p className="text-sm font-medium text-amber-800" data-testid={`text-${testIdPrefix}-progress`}>
          Setup incomplete — {filled} of {total} required fields set
        </p>
      </div>
      <p className="text-xs text-amber-700 mb-1.5">
        Fill in the {missing.length} remaining {missing.length === 1 ? "field" : "fields"} below before scanning:
      </p>
      <div className="flex flex-wrap gap-1.5" data-testid={`list-${testIdPrefix}-missing`}>
        {missing.map((f) => (
          <span
            key={f.key}
            className="inline-flex items-center rounded-full bg-amber-100 px-2.5 py-0.5 text-xs font-medium text-amber-800"
            data-testid={`chip-missing-${f.key}`}
          >
            {f.label}
          </span>
        ))}
      </div>
    </div>
  );
}
